import "./App.css";
import { useState } from "react";
import NavHeader from "./components/NavHeader";
import HeroImage from "./components/HeroImage";
// import TripleColumn from "./components/TripleColumn";
// import Services from "./components/Services";
import Footer from "./components/Footer";
import EstimateModal from './components/EstimateModal';
import Events from './components/Events';

function App() {
  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    console.log('open modal');
    setModalOpen(true);
  };
  const closeModal = () => setModalOpen(false);

  return (
    <div className="App">
      <NavHeader onOpenModal={openModal} />
      <HeroImage onOpenModal={openModal} />
      {/* <TripleColumn onOpenModal={openModal} /> */}
      {/* <Services onOpenModal={openModal} /> */}
      <Events onOpenModal={openModal} />
      <Footer />
      <EstimateModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
}

export default App;
